import _ from 'lodash';
import React from 'react';
import { PropTypes } from '~/utils';

import MenuBar from './MenuBar';
import Pages from './pages';

export default function MainApp( props ) {

  return (
    <>
      <header>
        <MenuBar />
      </header>
      <main>
        <Pages />
      </main>
      <footer>
      </footer>
    </>
  );
}

MainApp.propTypes = {
  children  : PropTypes.node,
};
